var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpeechBubble = function SvgSpeechBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.592,
    height: 24.771
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "speechBubble_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#066eba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03375d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "speechBubble_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 455",
    fill: "url(#speechBubble_svg__a)",
    d: "M0 0h23.592v24.771H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 169"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 168",
    clipPath: "url(#speechBubble_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 416",
    d: "m18.043 17.3.405-.536a8.914 8.914 0 1 0-3.083 2.584l.482-.246 3.47 1.391Zm5.549 7.474-7.643-3.065a11.35 11.35 0 1 1 4.8-4.066Z",
    fill: "url(#speechBubble_svg__a)"
  })))));
};

export default SvgSpeechBubble;